import { CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Axios from "axios";
import * as Yup from "yup";

import HDFCQuickReqBody from "../../Utilities/HealthInsuanceRequestBodies/QuickQuoteRequestBodies/HdfcQuickQuoteReqBody";
import { HdfcMedisureTopupReqBody } from "../../Utilities/HealthInsuanceRequestBodies/QuickQuoteRequestBodies/HdfcMedisureTopupReqBody";
import { HdfcOptimaRestoreReqBody } from "../../Utilities/HealthInsuanceRequestBodies/QuickQuoteRequestBodies/HdfcOptimaRestoreReqBody";

import starQuickReqBody from "../../Utilities/HealthInsuanceRequestBodies/QuickQuoteRequestBodies/StarQuickQuoteReqBody";
import careReqbodyGen from "../../Utilities/HealthInsuanceRequestBodies/QuickQuoteRequestBodies/CareQuickQuoteReqBody";

import QuickFieldArray from "./QuickFieldArray";
import TextError from "../../Components/HealthInsFormikComponent/TextError";
import goDigitQuickReqGenation from "../../Utilities/HealthInsuanceRequestBodies/QuickQuoteRequestBodies/GoDigitRequestBody";
import { handleAuth } from "../../Utilities/Common/handleAuth";

import { getDomain } from "../../Utilities/utils";
import { PRODUCT_LISTING_PAGE_ROUTE } from "../routes";
import { getLocalData } from "../../Utilities/Common/source";

const QuickQuoteForm = (props) => {
  console.log("props: ", props);
  // const [productDetails, setProductDetails] = useState([]);
  // const [clickedReset, setClickedReset] = useState(false);

  // const localSource = getLocalData("source");
  // console.log("QQ localSource: ", localSource);

  const [goldmineId, setGoldmineId] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const initialValues = {
    proposer_name: "",
    gender: "",
    pincode: "",
    period: "",
    insureds: [
      {
        relationShip: "",
        DOB: "",
        name: "",
        Age: "",
      },
    ],
    sumInsuredValue: "",
  };

  const validationSchema = Yup.object().shape({
    proposer_name: Yup.string()
      .required("First name is required !")
      .matches(/^[a-zA-Z]+([a-zA-Z ]*)$/, "Please give valid name")
      .min(3, "Name must have more than 3 digits"),

    pincode: Yup.string()
      .required("Pincode Required")
      .min(6, "Pin code must have 6 digits")
      .max(6, "Pin code must not exceed 6 digits"),
    period: Yup.string().required("Period is Required"),
    insureds: Yup.array()
      .of(
        Yup.object().shape({
          relationShip: Yup.string().required("Please select members"),
          name: Yup.string()
            .matches(/^[a-zA-Z]+([a-zA-Z ]*)$/, "Please give valid name")
            .min(3, "Name must have more than 3 digits")
            .required("Name is Required "),
          Age: Yup.string().required("Age is Required"),
        })
      )
      .required("Required"),
    sumInsuredValue: Yup.string().required("SumInsured value is Required"),
    gender: Yup.string().required("Must choose gender"),
  });

  const onSubmit = (values, { setSubmitting }) => {
    let golmineIdArray = goldmineId.split(":");

    const starReq = starQuickReqBody(values);

    const careReq = careReqbodyGen(values);
    const goDigitReq = goDigitQuickReqGenation(values);
    const HDFCREq = HDFCQuickReqBody(values);
    const hdfcMedisureTopupReq = HdfcMedisureTopupReqBody(values);
    const hdfcOptimaRestoreReq = HdfcOptimaRestoreReqBody(values);
    console.log("Hdfce Req body:", HDFCREq);

    let finalObject = {};
    if (HDFCREq !== null) {
      finalObject = {
        ...finalObject,
        starHealth: starReq,
        care: careReq,
        goDigit: goDigitReq,
        proposer_name: values["proposer_name"],
        gender: values["gender"],
        goldmineId: Number(golmineIdArray[1]),
        userId: Number(golmineIdArray[0]),
        hdfcHealth: HDFCREq,
        No_of_insureds: values["insureds"].length,
        pincode: values["pincode"],
        source: props.source,
      };
    } else {
      finalObject = {
        ...finalObject,
        starHealth: starReq,
        care: careReq,
        goDigit: goDigitReq,
        proposer_name: values["proposer_name"],
        gender: values["gender"],
        goldmineId: Number(golmineIdArray[1]),
        userId: Number(golmineIdArray[0]),
        No_of_insureds: values["insureds"].length,
        source: props.source,
      };
    }
    if (hdfcMedisureTopupReq !== null) {
      finalObject = { ...finalObject, hdfcMedisureTopup: hdfcMedisureTopupReq };
    }
    finalObject = {
      ...finalObject,
      hdfcOptimaRestore: hdfcOptimaRestoreReq,
      quickQuoteFormValues: values,
    };

    // Navigating to plp page with product list
    navigate(PRODUCT_LISTING_PAGE_ROUTE, {
      state: {
        isFirstVisit: true, // You can add other data as needed
        requestBody: JSON.stringify(finalObject),
        id: undefined,
      },
    });
  };

  useEffect(() => {
    const domain = getDomain();

    if (props.source === "posp") {
      // Check if source prop exists
      if (location.search === "") {
        if (window.location.hostname.trim() === "acuvisor.com") {
          handleAuth(false);
        }
        Axios.get(`${domain}/api/get-spot-id/8JTNvV0pFBFDTQEakGZ53A==`,{withCredentials:true}).then(
          (response) => {
            console.log("gold", response.data);
            setGoldmineId(response.data);
          }
        );
      } else {
        console.log("loc", location.search.split("="));
        let encryptId = location.search.split("=");
        Axios.get(`${domain}/api/get-spot-id/${encryptId[1]}`,{withCredentials:true}).then(
          (response) => {
            console.log("need", response);
            setGoldmineId(response.data);
          }
        );
      }
    }
  }, [props.source]);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => (
        <Form>
          {console.log("formik", formik)}
          <div className="form-container ">
            <h4 className="fw-bold HQ-title">Tell us about yourself</h4>
            <div className="form-group mb-3 " style={{ paddingTop: "20px" }}>
              <label
                htmlFor="inputName"
                className="fw-light"
                style={{ paddingBottom: "8px" }}
              >
                First Name
              </label>
              <div className="input-icons">
                <Field
                  type="text"
                  name="proposer_name"
                  id="inputName"
                  className={
                    formik.touched.proposer_name && formik.errors.proposer_name
                      ? " errorStyle form-control bg-white"
                      : !formik.errors.proposer_name &&
                        formik.touched.proposer_name
                      ? " successField form-control bg-white"
                      : " form-control bg-white"
                  }
                />
              </div>
              <ErrorMessage name="proposer_name" component={TextError} />
            </div>

            <div className="d-flex flex-nowrap justify-content-center bd-highlight mb-4">
              <div className="maleRadioGroup">
                <div className="radioGroupBelow">
                  <label htmlFor="maleGender">
                    <Field
                      type="radio"
                      name="gender"
                      value="Male"
                      id="maleGender"
                    />
                    <span>Male</span>
                  </label>
                </div>
              </div>

              <div className="femaleRadioGroup">
                <div className="radioGroupBelow">
                  <label htmlFor="maleGender">
                    <Field
                      type="radio"
                      name="gender"
                      value="Female"
                      id="maleGender"
                      className={formik.touched.name ? "successField" : null}
                    />
                    Female
                  </label>
                </div>
              </div>
            </div>
            <div className="d-flex flex-nowrap justify-content-center bd-highlight mb-4">
              <ErrorMessage name="gender" component={TextError} />
            </div>
            <div className="form-group mb-3 ">
              <label htmlFor="inpuPincode" className=" fw-light">
                Pincode
              </label>
              <div className="input-icons">
                <Field
                  type="number"
                  className={
                    formik.touched.pincode && formik.errors.pincode
                      ? "errorStyle form-control bg-white"
                      : !formik.errors.pincode && formik.touched.pincode
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                  }
                  name="pincode"
                  id="inpuPincode"
                  aria-describedby="nameHelp"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </div>

              <ErrorMessage name="pincode" component={TextError} />
            </div>
            <div className="form-group mb-3 ">
              <label htmlFor="inputPeriod">Period</label>
              <Field
                as="select"
                name="period"
                id="inputPeriod"
                className={
                  formik.touched.period && formik.errors.period
                    ? "errorStyle form-control bg-white"
                    : !formik.errors.period && formik.touched.period
                    ? "successField form-control bg-white"
                    : "form-control bg-white"
                }
              >
                <option value="">Select Period</option>
                <option value="1">One Year</option>
                <option value="2">Two Year</option>
                <option value="3">Three Year</option>
              </Field>
              <ErrorMessage name="period" component={TextError} />
            </div>

            <QuickFieldArray formik={formik} />

            {props.source !== "b2c" && (
              <div className="mb-4 ">
                <label htmlFor="inputAge fw-bold">Sum Assured</label>
                <Field
                  as="select"
                  name="sumInsuredValue"
                  id="inputAge"
                  className={
                    formik.touched.sumInsuredValue &&
                    formik.errors.sumInsuredValue
                      ? "errorStyle form-control bg-white"
                      : !formik.errors.sumInsuredValue &&
                        formik.touched.sumInsuredValue
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                  }
                >
                  <option value="">Select Options</option>
                  <option value="100000">1,00,000</option>
                  <option value="150000">1,50,000</option>
                  <option value="200000">2,00,000</option>
                  <option value="300000">3,00,000</option>
                  <option value="400000">4,00,000</option>
                  <option value="500000">5,00,000</option>
                </Field>
                <ErrorMessage name="sumInsuredValue" component={TextError} />
              </div>
            )}

            {props.source === "b2c" && (
              <div className="mb-4 ">
                <label htmlFor="inputAge fw-bold">Sum Assured</label>
                <Field
                  as="select"
                  name="sumInsuredValue"
                  id="inputAge"
                  className={
                    formik.touched.sumInsuredValue &&
                    formik.errors.sumInsuredValue
                      ? "errorStyle form-control bg-white"
                      : !formik.errors.sumInsuredValue &&
                        formik.touched.sumInsuredValue
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                  }
                >
                  <option value="">Select Options</option>
                  <option value="100000">1,00,000</option>
                  <option value="150000">1,50,000</option>
                  <option value="200000">2,00,000</option>
                  <option value="300000">3,00,000</option>
                  <option value="400000">4,00,000</option>
                  <option value="500000">5,00,000</option>
                  <option value="1000000">10,00,000</option>
                  <option value="1500000">15,00,000</option>
                  <option value="2000000">20,00,000</option>
                  <option value="2500000">25,00,000</option>
                  <option value="5000000">50,00,000</option>
                  <option value="10000000">1,00,00,000</option>
                  <option value="20000000">2,00,00,000</option>
                </Field>
                <ErrorMessage name="sumInsuredValue" component={TextError} />
              </div>
            )}
          </div>
          <div className=" btn-sec  position-fixed bottom-0 ">
            {formik.isSubmitting ? (
              <div className="mx-auto">
                <CircularProgress
                  size={48}
                  sx={{
                    color: "red",
                  }}
                />
              </div>
            ) : (
              <>
                <button className="reset-btn text-capitalize" type="reset">
                  Reset
                </button>
                <button
                  className="submitBtn text-capitalize "
                  type="submit"
                  disabled={formik.isSubmitting}
                >
                  Submit
                </button>
              </>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default QuickQuoteForm;
